module.exports = __webpack_public_path__ + "img/chongci_ps_23.d0f41506.jpg";